import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SERVERURL } from '../providers/constant';
import { forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import Pusher from 'pusher-js';


/*
  Generated class for the AuthServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/


@Injectable()
export class MyService {

  constructor(private http: HttpClient) { }

  apiData(method, Urlcomp, params, body) {
    let url = SERVERURL + Urlcomp;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'cache-control': 'no-cache'
    });
    let safeParams = (params && typeof params === 'object') ? params : {};

    if (method === 'GET') {
      return this.http.get(url, { headers: headers, params: safeParams });
    } else {
      return this.http.post(url, body || {}, { headers: headers, params: safeParams });
    }
  }

  getUserQuestionnaireStatus(clientId) {
    // We use catchError(err => of(null)) so one failure doesn't stop the forkJoin
    return forkJoin([
      this.apiData('GET', '/api/getSignClientById/' + clientId, {}, {}).pipe(catchError(() => of(null))),
      this.apiData('GET', '/api/getDataAnswersClientById/' + clientId, {}, {}).pipe(catchError(() => of(null))),
      this.apiData('GET', '/api/getParQClientByClient/' + clientId, {}, {}).pipe(catchError(() => of(null))),
      this.apiData('GET', '/api/getClientLifestyleMatchingEvaluations/' + clientId, {}, {}).pipe(catchError(() => of(null)))
    ]).pipe(
      map(([consent, initial, parq, lifestyle]) => {
        return {
          consentForm: this.isValid(consent, 'Consent'),
          initialQ: this.isValid(initial, 'InitialQ'),
          parQ: this.isValid(parq, 'ParQ'),
          lifestyle: this.isValid(lifestyle, 'Lifestyle')
        };
      })
    );
  }

  private isValid(data: any, name: string): boolean {
    console.log(`Data for ${name}:`, data); // Check your console with this!
    if (!data) return false;
    if (Array.isArray(data)) return data.length > 0;
    if (typeof data === 'object') {
        // Return true if object has keys and is not an error response
        return Object.keys(data).length > 0 && !data.error && !data.message_error;
    }
    return false;
  }

  getWellnessResults(clientId: any) {
  // Ajusta esta URL a la ruta real de tu backend que devuelve los resultados de las respuestas
  // Por ejemplo: return this.http.get(`${this.apiUrl}/getWellnessResults/${clientId}`);

  // Por ahora, para que compile y funcione, puedes retornar el endpoint que ya uses:
  return this.http.get('https://app.walba.app/api/getFitnessAssessmentByIdClient/' + clientId);
}
}

@Injectable()
export class PusherServiceProvider {
  presenceChannel;

  constructor(public http: HttpClient) {
 /*   let pusher = new Pusher('f8432cbe217341d4549b', {
      wsHost:'fitafter50.ml',
      wsPort: 6001,
      wssPort: 6001,
      cluster: 'us2',
      disableStats: true
    });

    this.presenceChannel = pusher.subscribe('test');*/
  }


/*
  public init() {
    return this.presenceChannel;
  }
*/

  public init(channel){

    let pusher = new Pusher('f8432cbe217341d4549b', {
      wsHost:'app.walba.app',
      wsPort: 6001,
      wssPort: 6001,
      cluster: 'us2',
      disableStats: true
    });

    this.presenceChannel = pusher.subscribe('Session_'+channel);
    return this.presenceChannel;
  }




}
